import * as React from 'react';
import useCurrentUser from './useCurrentUser';

const useExternalTypeId = () => {
  const { isOrganizationAdmin, parentOrganizationId, groupsWithAdminRight, isDone } = useCurrentUser();

  const { externalType, externalId, externalTypeLicense, externalIdLicense } = React.useMemo(() => {
    const externalId = isOrganizationAdmin
      ? parentOrganizationId!
      : (groupsWithAdminRight.length && groupsWithAdminRight[0].id) || '';
    return {
      externalType: isOrganizationAdmin ? 'organization' : ('group' as 'organization' | 'group'),
      externalTypeLicense: parentOrganizationId ? 'organization' : 'group',
      externalIdLicense: parentOrganizationId || externalId,
      externalId,
    };
  }, [isOrganizationAdmin, parentOrganizationId, groupsWithAdminRight]);

  return { isLoaded: isDone, externalType, externalTypeLicense, externalId, externalIdLicense };
};

export default useExternalTypeId;
